var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.listaPrazoPagto,"item-text":"nmPrazo","item-value":"cdPrazo","label":"Prazo","outlined":"","hide-details":"","dense":_vm.dense},on:{"change":_vm.onSelectPrazo},model:{value:(_vm.cdPrazo),callback:function ($$v) {_vm.cdPrazo=$$v},expression:"cdPrazo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }